
<script context="module">

import { 
  VmDash,
  VmFile,
  VmVideo 
} from '@vime/core';

import { define } from '../lib';
  

define('vm-dash', VmDash);
define('vm-file', VmFile);
define('vm-video', VmVideo);
  
</script>

<script>
import { createEventDispatcher, onMount } from 'svelte';
import { setProp } from '../lib';

let __ref;
let __mounted = false;

const dispatch = createEventDispatcher();

let className;

export let style;
export { className as class };

export let src;
export let version = 'latest';
export let libSrc = undefined;
export let config = {};
export let autoplay = false;
export let crossOrigin = undefined;
export let preload = 'metadata';
export let poster = undefined;
export let controlsList = undefined;
export let autoPiP = undefined;
export let disablePiP = undefined;
export let disableRemotePlayback = undefined;
export let mediaTitle = undefined;
export let enableTextTracksByDefault = true;
export let shouldRenderNativeTextTracks = true;
export let isTextTrackVisible = true;
export let currentTextTrack = -1;
export const getAdapter = (...args) => __ref.getAdapter(...args);
export const ref = () => __ref;
export const getWebComponent = () => __ref;

onMount(() => { 
  

  __mounted = true; 
});

$: if (__mounted) setProp(__ref, 'config', config);

const onEvent = (e) => {
  e.stopPropagation();
  dispatch(e.type, e.detail);
};
</script>

<vm-dash 
  class={className}
  style={style}
  src={src}
  version={version}
  lib-src={libSrc}
  autoplay={autoplay}
  cross-origin={crossOrigin}
  preload={preload}
  poster={poster}
  controls-list={controlsList}
  auto-pip={autoPiP}
  disable-pip={disablePiP}
  disable-remote-playback={disableRemotePlayback}
  media-title={mediaTitle}
  enable-text-tracks-by-default={enableTextTracksByDefault}
  should-render-native-text-tracks={shouldRenderNativeTextTracks}
  is-text-track-visible={isTextTrackVisible}
  current-text-track={currentTextTrack}
  on:vmLoadStart={onEvent}
  on:vmError={onEvent}
  bind:this={__ref}
>
  <slot></slot>
</vm-dash>
  